import { Asset } from '../..';
import { directTreasurySellOffersQueryUpdated } from '../../../../../../../../store/product/selectors';

import { DirectTreasurySellListItem } from './ListItem';
import { ListLoadingItem } from './ListLoadingItem';

export const DirectTreasuryAsset = () => {
  return (
    <Asset
      productsQuery={directTreasurySellOffersQueryUpdated}
      ProductItem={DirectTreasurySellListItem}
      ProductItemLoading={ListLoadingItem}
      keySelector="productId"
    />
  );
};
